var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-custom-button",on:{"click":function($event){$event.stopPropagation();return _vm.action.apply(null, arguments)}}},[_c('a-icon',{attrs:{"type":"plus"}}),_vm._v(" "),_c('span',{staticClass:"add-custom-button__link"},[_vm._v("Add")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }